var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-contact-us-rap" },
    [
      _c(
        "component-wrapper",
        { attrs: { spacing: "bottom" } },
        [
          _c(
            "FormContainer",
            {
              attrs: {
                currentStep: _vm.currentStep,
                steps: _vm.steps,
                showProgressBar: _vm.showProgressBar,
                title: _vm.config && _vm.config.heading
              }
            },
            [
              _c(
                "step-panel",
                { attrs: { isVisible: _vm.showLocationStep } },
                [
                  _c(
                    "component-wrapper",
                    [
                      _c(
                        "form-section",
                        { attrs: { title: _vm.content.locationTitle } },
                        [
                          _c("div", { staticClass: "c-form__group" }, [
                            _c("div", {
                              staticClass: "c-rte",
                              domProps: {
                                innerHTML: _vm._s(_vm.content.locationDesc)
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("problem-location", {
                            attrs: {
                              showIsAtProperty: _vm.showIsAtProperty,
                              isAtProperty: _vm.isAtProperty,
                              isProblemAtAddressLabel:
                                _vm.content.isProblemAtAddressLabel,
                              backButtonText: _vm.content.backButtonText,
                              continueButtonText:
                                _vm.content.continueButtonText,
                              isLoading: _vm.isLoading,
                              locateProblemOutOfPropertyTitle:
                                _vm.content.locateProblemOutOfPropertyTitle,
                              locateProblemOutOfPropertyDesc:
                                _vm.content.locateProblemOutOfPropertyDesc,
                              locateProblemAtPropertyTitle:
                                _vm.content.locateProblemAtPropertyTitle,
                              locateProblemAtPropertyDesc:
                                _vm.content.locateProblemAtPropertyDesc,
                              lookupPostcodeLabel:
                                _vm.content.lookupPostcodeLabel,
                              lookupCustomerReferenceLabel:
                                _vm.content.lookupCustomerReferenceLabel,
                              lookupPostcodeDesc:
                                _vm.content.lookupPostcodeDesc,
                              searchButtonLabel: _vm.content.searchButtonLabel,
                              postcodeNotListed: _vm.content.postcodeNotListed,
                              postcodeNotAllowed:
                                _vm.content.postcodeNotAllowed,
                              customerReferenceNotListed:
                                _vm.content.customerReferenceNotListed,
                              customerReferenceNotAllowed:
                                _vm.content.customerReferenceNotAllowed,
                              customersOnly: _vm.config.customersOnly
                            },
                            on: {
                              isAtPropertyChange: _vm.isAtPropertyChange,
                              updateAddress: _vm.confirmLocation,
                              updateCustomerReference:
                                _vm.updateCustomerReference,
                              stepChange: function($event) {
                                return _vm.stepChange(1)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "step-panel",
                { attrs: { isVisible: _vm.showStepOne } },
                [
                  _c(
                    "component-wrapper",
                    [
                      _c("form-section", {
                        attrs: {
                          title: _vm.content.stepOneTitle,
                          desc: _vm.content.stepOneDesc
                        }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.wizard, function(question, index) {
                        return _c(
                          "div",
                          {
                            key: question.id,
                            staticClass: "c-form__group",
                            attrs: { id: question.id }
                          },
                          [
                            _c(question.type, {
                              tag: "component",
                              attrs: {
                                index: index,
                                question: question,
                                activeTooltipId: _vm.activeTooltip
                              },
                              on: {
                                "hook:mounted": function($event) {
                                  return _vm.scrollToComponent(question.id)
                                },
                                input: _vm.updateQuestions,
                                activeTooltip: _vm.setActiveTooltip
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm.offerUpload && _vm.isFinalQuestion
                        ? _c(
                            "div",
                            { staticClass: "c-form__group" },
                            [
                              _c("upload-box", {
                                attrs: {
                                  extensions: _vm.extensions,
                                  uploadPostAction: _vm.fileUploadAction,
                                  title: _vm.content.uploadTitle,
                                  intro: _vm.content.uploadIntro
                                },
                                on: {
                                  resetFile: _vm.resetFile,
                                  fileUpload: _vm.setFileId,
                                  isUploadingFile: _vm.setUploadingFile
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("action-buttons", {
                        attrs: {
                          prevLabel: _vm.content.backButtonText,
                          nextLabel: _vm.content.continueButtonText,
                          nextDisabled: _vm.stepTwoIsDisabled
                        },
                        on: {
                          onPrev: function($event) {
                            return _vm.stepChange(0)
                          },
                          onNext: function($event) {
                            return _vm.collateAnswers()
                          }
                        }
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "step-panel",
                { attrs: { isVisible: _vm.showStepTwo } },
                [
                  _c(
                    "component-wrapper",
                    [
                      _c("form-section", {
                        attrs: {
                          title: _vm.content.stepTwoTitle,
                          desc: _vm.content.stepTwoDesc
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "component-wrapper",
                    { attrs: { spacing: "bottom" } },
                    [
                      _c("user-details", {
                        attrs: {
                          aboutYouEmailLabel: _vm.content.aboutYouEmailLabel,
                          aboutYouConfirmEmailLabel:
                            _vm.content.aboutYouConfirmEmailLabel,
                          aboutYouFirstNameLabel:
                            _vm.content.aboutYouFirstNameLabel,
                          aboutYouOtherTitleLabel:
                            _vm.content.aboutYouOtherTitleLabel,
                          aboutYouPrimaryContactLabel:
                            _vm.content.aboutYouPrimaryContactLabel,
                          aboutYouPrimaryContactToolTip:
                            _vm.content.aboutYouPrimaryContactToolTip,
                          aboutYouEmailToolTip:
                            _vm.content.aboutYouEmailToolTip,
                          aboutYouSecondaryContactLabel:
                            _vm.content.aboutYouSecondaryContactLabel,
                          aboutYouSurnameLabel:
                            _vm.content.aboutYouSurnameLabel,
                          aboutYouCustomerReferenceNumberLabel:
                            _vm.content.aboutYouCustomerReferenceNumberLabel,
                          aboutYouTitleLabel: _vm.content.aboutYouTitleLabel,
                          aboutYouCustomerReferenceNumberTooltip:
                            _vm.content.aboutYouCustomerReferenceNumberTooltip,
                          aboutYouAdditionalNeedsTooltip:
                            _vm.content.aboutYouAdditionalNeedsTooltip,
                          aboutYouAdditionalNeedsLabel:
                            _vm.content.aboutYouAdditionalNeedsLabel,
                          aboutYouAdditionalNeedsDesc:
                            _vm.content.aboutYouAdditionalNeedsDesc,
                          email: _vm.email,
                          confirmEmail: _vm.confirmEmail,
                          firstName: _vm.firstName,
                          surname: _vm.surname,
                          customerReferenceNumber: _vm.customerReferenceNumber,
                          additionalNeeds: _vm.additionalNeeds,
                          otherTitle: _vm.otherTitle,
                          primaryContact: _vm.primaryContact,
                          secondaryContact: _vm.secondaryContact,
                          primaryContactType: _vm.primaryContactType,
                          secondaryContactType: _vm.secondaryContactType,
                          title: _vm.title,
                          activeTooltipId: _vm.activeTooltip,
                          backButtonText: _vm.content.backButtonText,
                          continueButtonText: _vm.content.continueButtonText
                        },
                        on: {
                          collateDetails: _vm.collateDetails,
                          onPrev: function($event) {
                            return _vm.stepChange(1)
                          },
                          valueChange: _vm.formBoxValueChange,
                          activeTooltip: _vm.setActiveTooltip
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "step-panel",
                { attrs: { isVisible: _vm.showStepThree } },
                [
                  _c(
                    "component-wrapper",
                    [
                      _c(
                        "form-section",
                        {
                          attrs: {
                            title: _vm.content.stepThreeTitle,
                            desc: _vm.content.stepThreeDesc
                          }
                        },
                        [
                          _c("form-review", {
                            attrs: { sections: _vm.formSections },
                            on: { editSection: _vm.handleSectionEdit }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "component-wrapper",
                    [
                      _c("action-buttons", {
                        attrs: {
                          prevLabel: _vm.content.backButtonText,
                          nextLabel: _vm.content.submitButtonText,
                          nextType: _vm.submit,
                          nextDisabled: _vm.isLoading,
                          nextLoading: _vm.isLoading
                        },
                        on: {
                          onPrev: function($event) {
                            return _vm.stepChange(2)
                          },
                          onNext: _vm.postIncidentReport
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "step-panel",
                { attrs: { isVisible: _vm.showStepFour } },
                [
                  _c(
                    "component-wrapper",
                    { attrs: { spacing: "bottom" } },
                    [
                      _c(
                        "form-section",
                        {
                          attrs: {
                            title: _vm.confirmationTitle,
                            desc: _vm.confirmationMessage
                          }
                        },
                        [
                          _c("div", [
                            _vm.confirmationReference
                              ? _c("div", [
                                  _c("strong", [
                                    _vm._v(
                                      "Incident Number:\n                  "
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.confirmationReference) +
                                          "\n                  "
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  !_vm.isLoggedIn
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-contact-us-rap__signup c-bordered-content"
                                        },
                                        [
                                          _c(
                                            "form",
                                            {
                                              attrs: {
                                                action: "/RapSignUp",
                                                method: "post"
                                              }
                                            },
                                            [
                                              _c(
                                                "h3",
                                                {
                                                  staticClass:
                                                    "c-contact-us-rap__heading"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.content
                                                          .createAccount.title
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.content.createAccount
                                                      .text
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("input", {
                                                attrs: {
                                                  type: "hidden",
                                                  name: "IncidentId"
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.confirmationReference
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("input", {
                                                attrs: {
                                                  type: "hidden",
                                                  name: "Email"
                                                },
                                                domProps: {
                                                  value: _vm.formBoxData.email
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("input", {
                                                attrs: {
                                                  type: "hidden",
                                                  name: "Title"
                                                },
                                                domProps: {
                                                  value: _vm.formBoxData.title
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("input", {
                                                attrs: {
                                                  type: "hidden",
                                                  name: "OtherTitle"
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.formBoxData.otherTitle
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("input", {
                                                attrs: {
                                                  type: "hidden",
                                                  name: "Firstname"
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.formBoxData.firstName
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("input", {
                                                attrs: {
                                                  type: "hidden",
                                                  name: "Lastname"
                                                },
                                                domProps: {
                                                  value: _vm.formBoxData.surname
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("input", {
                                                attrs: {
                                                  type: "hidden",
                                                  name: "Postcode"
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.address.propertyPostcode
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("input", {
                                                attrs: {
                                                  type: "hidden",
                                                  name: "PrimaryContactNumber"
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.formBoxData
                                                      .primaryContact
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "c-button c-button--brand-alt c-contact-us-rap__button",
                                                  attrs: { type: "submit" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.content
                                                          .createAccount
                                                          .buttonText
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1eba4384", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eba4384","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/_contact-us-rap/_vue/ReportProblem.vue
// module id = 771
// module chunks = 0